import { isClient } from '../../utils/isClient';
import type { ImageSizes } from './types';

export const getSourceFromRatio = (images: ImageSizes) => {
  if (!isClient()) {
    return images.x1;
  }

  const cappedRatio = Math.min(3, Math.max(1, Math.ceil(window.devicePixelRatio)));

  return images[`x${cappedRatio}`] || images.x1;
};

export const defaultPreloadImage = (src: string) =>
  new Promise<string>((resolve, reject) => {
    const img = document.createElement('img');
    img.onload = () => resolve(src);
    img.onerror = () => reject(new Error(`Failed to preload ${src}`));
    img.src = src;
  });

export const getCurrentPreloadId = (src: string) => Symbol(`LazyImage ${src} preload-id`);
